import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import swal, * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
import { DomSanitizer } from '@angular/platform-browser';
//grid
import { AgGridNg2 } from 'ag-grid-angular';
import { PieChartConfig } from '../GCharts/PieChartConfig';
import { } from '@types/googlemaps';
//reporte
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import { empty } from 'rxjs/Observer';
import { saveAs as importedSaveAs } from "file-saver";

import { ViajeRecorrido } from '../Models/ViajeRecorrido';
import { ReporteViaje } from '../Models/ReporteViaje';
import { ReporteVisita } from '../Models/ReporteVisita';
import { ReporteTarea } from '../Models/ReporteTarea';
import { Usuario } from '../Models/Usuario';
import { Vehiculo } from '../Models/Vehiculo';
import { VisitaIncidencia } from '../Models/VisitaIncidencia';
import { Nota } from '../Models/Nota';

import { GlobalsService } from '../services/globals.service';
import { ReporteViajeService } from '../services/reporte-viaje.service';
import { UsuarioService } from '../services/usuario.service';
import { VehiculoService } from '../services/vehiculo.service';
import { ViajeRecorridoService } from '../services/viaje-recorrido.service';
import { GeneradorTemplateService } from '../services/generador-template.service';
import { UtilesService } from '../services/utiles.service';
import { Alert } from 'selenium-webdriver';



@Component({
  selector: 'app-reporteviaje',
  templateUrl: './reporteviaje.component.html',
  styleUrls: ['./reporteviaje.component.css']
})
export class ReporteviajeComponent implements OnInit {


  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;

  @ViewChild('gmapvisitas') gmapElementVisitas: any;
  mapVisitas: google.maps.Map;


  public reporteViaje: ReporteViaje = new ReporteViaje();
  public reporteViajes: ReporteViaje[];

  public reporteVisita: ReporteVisita = new ReporteVisita();
  public reporteVisitas: ReporteVisita[];

  public reporteTarea: ReporteTarea = new ReporteTarea();
  public reporteTareas: ReporteTarea[];

  public nota: Nota = new Nota();
  public Notas: Nota[];

  public nombreUsuario: string;
  public nombrePunto: string;
  public idVehiculo: string;
  public fechaInicio: Date;
  public fechaFin: Date;
  public numeroGuia: string;

  public path: any;


  public mostrarReporteViajes: boolean = false;
  public mostrarReporteVisitas: boolean = false;
  public mostrarReporteTareas: boolean = false;
  public mostrarIncidencia: boolean = false;
  //public modoEdicion: boolean=false;

  public usuario: Usuario = new Usuario();
  public usuarios: Usuario[];

  public vehiculo: Vehiculo = new Vehiculo();
  public vehiculos: Vehiculo[];

  public visitaIncidencia: VisitaIncidencia = new VisitaIncidencia();
  public visitaIncidencias: VisitaIncidencia[];


  public latitude: number = 9.935638;
  public longitude: number = -84.143464;
  public marcadoresNota = [];
  public viajeRecorridoMovimiento: Array<ViajeRecorrido> = new Array<ViajeRecorrido>();
  public rastroMovimientoColeccion = [];



  constructor(private reporteService: ReporteViajeService, private globalServices: GlobalsService,
    private domSanitizer: DomSanitizer, private usuarioService: UsuarioService,
    private vehiculoService: VehiculoService, private viajeRecorridoService: ViajeRecorridoService,
    private generadorTemplate: GeneradorTemplateService, private utilesService: UtilesService) {

  }

  ngOnInit() {

    this.mostrarReporteVisitas = true;
    this.mostrarReporteTareas = true;
    this.CargarVehiculos();
    this.CargarUsuarios();
  }


  cagarMapa() {

    this.map = new google.maps.Map(this.gmapElement.nativeElement, {
      center: {
        lat: parseFloat(this.reporteVisita.latitud),
        lng: parseFloat(this.reporteVisita.longitud)
      },
      zoom: 21
    });

  }

  cagarMapaReporteVisitas() {

    this.reporteVisitas.forEach(element => {


      this.mapVisitas = new google.maps.Map(this.gmapElementVisitas.nativeElement, {
        center: {
          lat: parseFloat(element.latitud),
          lng: parseFloat(element.longitud)
        },
        zoom: 13
      });
    });
  }


  dibujarMapa() {
    try {

      this.Notas.forEach(element => {

        if (this.visitaIncidencias != undefined) {
          let index = this.visitaIncidencias.findIndex(incidencia => incidencia.idVisita === element.idVisita);
          this.visitaIncidencia = this.visitaIncidencias[index];

        }
        else {
          this.visitaIncidencia = undefined;
        }


        var contenido;



        if (this.visitaIncidencia === undefined) {
          contenido = "<div><img width='254' height='355' src='data:image/png;base64," + element.imagen + "'<br>  </div>";
        }
        else {
          contenido = "<div><img width='254' height='355' src='data:image/png;base64," + element.imagen + "'<br> <h4> Motivo: " + this.visitaIncidencia.motivo + "</h4> </div>";
        }
        var marker = new google.maps.Marker({

          position: { lat: parseFloat(element.latitud), lng: parseFloat(element.longitud) },
          map: this.map,
          title: "",
          icon: {
            size: new google.maps.Size(220, 220),
            scaledSize: new google.maps.Size(60, 60),
            origin: new google.maps.Point(0, 0),
            url: "data:image/png;base64," + element.imagen,
            anchor: new google.maps.Point(16, 16)

          }

        }),
          infowindow = new google.maps.InfoWindow({
            content: contenido
          });
        //le da click a la fotografia
        google.maps.event.addListener(marker, 'click', function () {

          infowindow.open(this.map, marker);

        });

        this.marcadoresNota.push(marker);
      });


    } catch (error) {

    }
  }

  dibujarMapaReporteVisitas() {
    try {

      this.reporteVisitas.forEach(element => {
        let contenido = "<div> <h4>" + element.nombrePunto + "</h4> </div>";
        var marker = new google.maps.Marker({

          position: { lat: parseFloat(element.latitud), lng: parseFloat(element.longitud) },
          map: this.mapVisitas,
          title: "",
        }),

          infowindow = new google.maps.InfoWindow({
            content: contenido
          });

        google.maps.event.addListener(marker, 'click', function () {

          infowindow.open(this.map, marker);

        });
        this.marcadoresNota.push(marker);

      });





    } catch (error) {

    }
  }




  CargarReporteViajes() {
    try {
      if (this.usuario.idUsuario === undefined || this.usuario.idUsuario === "") {
        this.usuario.idUsuario = null;
      }
      if (this.nombrePunto === undefined || this.nombrePunto === "") {
        this.nombrePunto = null;
      }
      if (this.vehiculo.idvehiculo === undefined || this.vehiculo.idvehiculo === "") {
        this.vehiculo.idvehiculo = null;
      }
      if (this.fechaInicio === null) {
        this.fechaInicio = undefined;
      }

      if (this.fechaInicio === undefined || this.fechaInicio.toString() == "") {
        this.fechaInicio = null;
      }

      if (this.fechaFin === null) {
        this.fechaFin = undefined;
      }

      if (this.fechaFin === undefined || this.fechaFin.toString() == "") {
        this.fechaFin = null;
      }
      if (this.numeroGuia === undefined) {
        this.numeroGuia = null;
      }


      this.reporteService.ObtenerReporteViaje(this.globalServices.ObtenerCompania(), this.usuario.idUsuario, this.nombrePunto
        , this.vehiculo.idvehiculo, this.fechaInicio,
        this.fechaFin).subscribe(
          data => {
            this.reporteViajes = data;

          },
          err => {
            console.clear();
            console.log(err._body);

          });


    } catch (error) {
      console.log("cargar reporte viajes: " + error);
    }

  }


  RegistroSeleccionado(item) {

    this.reporteViaje = JSON.parse(JSON.stringify(item));

    this.CargarReporteVisitas(this.reporteViaje.idUsuario, this.reporteViaje.idVehiculo, this.reporteViaje.idViaje);

    this.mostrarReporteVisitas = false;
    this.mostrarReporteViajes = true;
    this.mostrarReporteTareas = true;
  }

  RegistroSeleccionadoVisita(item) {

    this.reporteVisita = JSON.parse(JSON.stringify(item));

    if (this.reporteVisita.estado === "PROCESADO") {

      this.path = this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.reporteVisita.imagen);

      this.CargarReporteTareas(this.reporteViaje.idUsuario, this.reporteVisita.idVisita);
      this.mostrarReporteVisitas = true;
      this.mostrarReporteViajes = true;
      this.mostrarReporteTareas = false;
      this.mostrarIncidencia = false;
    }
    else {
      if (this.reporteVisita.estado === "ABORTADO") {
        this.CargarReporteTareas(this.reporteViaje.idUsuario, this.reporteVisita.idVisita);
        this.CargarReportePuntoVisitaAbortado(this.reporteViaje.idUsuario, this.reporteVisita.idVisita);


        this.mostrarReporteVisitas = true;
        this.mostrarReporteViajes = true;
        this.mostrarReporteTareas = false;
        this.mostrarIncidencia = true;
      }
      else {
        swal("No se puede mostrar el reporte de certificación, el viaje no se ha procesado", "", "error");
        return;
      }
    }

  }


  CargarReporteVisitas(idUsuario: string, idVehiculo: string, idViaje: string) {
    try {


      this.reporteService.ObtenerReporteVisitas(this.globalServices.ObtenerCompania(), idUsuario, idVehiculo, idViaje).subscribe(
        data => {
          this.reporteVisitas = data;

          this.cagarMapaReporteVisitas();
          this.dibujarMapaReporteVisitas();
          this.CargarMapaMovimiento(this.reporteViaje.idViaje);
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarReporteVisitas: " + error);
    }

  }


  CargarReporteTareas(idCompania: string, idVisita: string) {
    try {

      this.reporteService.ObtenerReporteTarea(this.globalServices.ObtenerCompania(), idVisita).subscribe(
        data => {
          this.reporteTareas = data;

          this.CargarNotasVisita(idVisita);
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarReporteTareas: " + error);
    }

  }

  CargarReportePuntoVisitaAbortado(idCompania: string, idVisita: string) {
    try {


      this.reporteService.ObtenerReportePuntoVisitaAbortado(this.globalServices.ObtenerCompania(), idVisita).subscribe(
        data => {
          this.visitaIncidencias = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarReportePuntoVisitaAbortado: " + error);
    }

  }
  download() {
    html2canvas(document.getElementById('tablavisita')).then(function (canvas) {
      var img = canvas.toDataURL("image/png");

      var doc = new jsPDF();
      doc.text(5, 10, 'Punto de visita')
      doc.addImage(img, 'JPEG', 5, 15, 200, 50);
      doc.save('Test1.pdf');

    });
  }


  CargarVehiculos() {

    try {

      this.vehiculoService.ObtenerVehiculos(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.vehiculos = data;



        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarUsuarios: " + error);
    }
  }



  CargarUsuarios() {

    try {

      this.usuarioService.ObtenerUsuariosComboBox(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.usuarios = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarUsuarios: " + error);
    }
  }

  RegresarReporteVisitas() {
    this.mostrarReporteVisitas = true;
    this.mostrarReporteViajes = false;
    this.mostrarReporteTareas = true;

  }


  RegresarReporteTareas() {
    this.mostrarReporteVisitas = false;
    this.mostrarReporteViajes = true;
    this.mostrarReporteTareas = true;
    //  this.visitaIncidencia=new VisitaIncidencia();
    //this.visitaIncidencias=[];
    this.CargarReporteVisitas(this.reporteViaje.idUsuario, this.reporteViaje.idVehiculo, this.reporteViaje.idViaje);
  }


  CargarMapaMovimiento(idViaje: string) {
    try {

      return this.viajeRecorridoService.ObtenerViajeRecorridoMovimiento(this.globalServices.ObtenerCompania(), idViaje).subscribe(
        data => {

          this.viajeRecorridoMovimiento = data;

          this.rastroMovimiento();

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarMapaMovimiento: " + error);
    }
  }


  rastroMovimiento() {
    try {



      this.viajeRecorridoMovimiento.forEach(element => {
        var cityCircle = new google.maps.Circle({
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 0,
          fillColor: '#77f442',
          fillOpacity: 0.25,
          map: this.mapVisitas,
          center: { lat: parseFloat(element.latitud), lng: parseFloat(element.longitud) },
          radius: 100
        });
        this.rastroMovimientoColeccion.push(cityCircle);
      });


    } catch (error) {
      console.error("rastro movimiento: " + error);
    }


  }

  //Centra a la primera imagen en las incidencias
  CentrarEvidencia() {
    try {

      if (this.Notas.length === 0) {
        swal("No se puede centrar el mapa, el punto de visita no contiene evidencias", "", "error");
        return;

      }


      this.map = new google.maps.Map(this.gmapElement.nativeElement, {
        center: {
          lat: parseFloat(this.Notas[0].latitud),
          lng: parseFloat(this.Notas[0].longitud)
        },
        zoom: 21
      });

      this.Notas.forEach(element => {

        if (this.visitaIncidencias != undefined) {
          let index = this.visitaIncidencias.findIndex(incidencia => incidencia.idVisita === element.idVisita);
          this.visitaIncidencia = this.visitaIncidencias[index];

        }
        else {
          this.visitaIncidencia = undefined;
        }

        var contenido;

        if (this.visitaIncidencia === undefined) {
          contenido = "<div><img width='254' height='355' src='data:image/png;base64," + element.imagen + "'<br>  </div>";
        }
        else {
          contenido = "<div><img width='254' height='355' src='data:image/png;base64," + element.imagen + "'<br> <h4> Motivo: " + this.visitaIncidencia.motivo + "</h4> </div>";
        }
        var marker = new google.maps.Marker({

          position: { lat: parseFloat(element.latitud), lng: parseFloat(element.longitud) },
          map: this.map,
          title: "",
          icon: {
            size: new google.maps.Size(220, 220),
            scaledSize: new google.maps.Size(60, 60),
            origin: new google.maps.Point(0, 0),
            url: "data:image/png;base64," + element.imagen,
            anchor: new google.maps.Point(16, 16)

          }

        }),
          infowindow = new google.maps.InfoWindow({
            content: contenido
          });

        google.maps.event.addListener(marker, 'click', function () {

          infowindow.open(this.map, marker);

        });

        this.marcadoresNota.push(marker);
      });


    } catch (error) {

    }


  }


  CargarNotasVisita(idVisita: string) {
    try {


      this.reporteService.ObtenerNotasVisita(this.globalServices.ObtenerCompania(), idVisita).subscribe(
        data => {
          this.Notas = data;

          this.cagarMapa();
          this.dibujarMapa();

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarNotasVisita: " + error);
    }

  }

  /**
   * Metodo que descarga el reporte
   */
  DescargarReporte() {

    //nombre que va a tener el archivo
    var nombre = "Reporte Viaje" + this.reporteVisita.idVisita;
    var archivo = this.utilesService.getURLReportes() + nombre + ".pdf";

    //Genera el arciho PDF en la api
    this.generadorTemplate.ReporteViaje(this.globalServices.ObtenerCompania(), this.reporteViaje.idViaje, this.reporteVisita.idVisita, nombre).subscribe(
      (res) => {

        if(res.tipoResultado==="ERROR"){
          swal("Error, "+ res.mensaje, "", "error");
            return
        }

        var resultado = 'data:application/pdf;base64,' + res.objetoResultado;
        var fileName = "Reporte Viaje.pdf";

        importedSaveAs(resultado, fileName);

      
      }
    )
  }

  bufferToBase64(buf) {
    var binstr = Array.prototype.map.call(buf, function (ch) {
      return String.fromCharCode(ch);
    }).join('');
    return btoa(binstr);
  }


  base64ToArrayBuffer(base64: string) {
    const binaryString = window.atob(base64); // Comenta esto si no estás usando base64 
    const bytes = new Uint8Array(binaryString.length);
    return bytes.map((byte, i) => binaryString.charCodeAt(i));
  }

  createAndDownloadBlobFile(body, filename, extension = 'pdf') {
    const blob = new Blob([body]);
    const fileName = `${filename}.${extension}`;
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }


}
